import { fetchSoldHoldings } from 'views/Portfolio/components/Details/services/fetchSoldHoldings';
import { ToolExecutionResult } from '../types';
import { formatCurrency, formatPercentage } from '../utils/formatters';

export const executeGetSoldHoldings = async (args: Record<string, unknown>): Promise<ToolExecutionResult> => {
  try {
    const limit = (args.limit as number) || 20;
    const response = await fetchSoldHoldings({ limit });

    if (!response.data || response.data.length === 0) {
      return {
        success: true,
        data: {
          message: 'No sold holdings found. You have not sold any wines yet.',
          holdings: [],
          count: 0,
        },
      };
    }

    const holdings = response.data.slice(0, limit).map((holding) => {
      const pnl = holding.profitAndLoss || 0;
      const cost = holding.totalCost || 0;
      const pnlPct = cost > 0 ? (pnl / cost) * 100 : 0;
      return {
        wineName: holding.wineName || holding.lwin18,
        vintage: holding.vintage,
        region: holding.cultWinesAllocationRegion,
        quantity: holding.qty,
        soldValue: formatCurrency(holding.totalValue || 0),
        costBasis: formatCurrency(cost),
        profitAndLoss: formatCurrency(pnl),
        profitAndLossPct: formatPercentage(pnlPct),
        status: holding.status,
      };
    });

    // Calculate summary stats
    const totalSoldValue = response.data.reduce((sum, h) => sum + (h.totalValue || 0), 0);
    const totalCost = response.data.reduce((sum, h) => sum + (h.totalCost || 0), 0);
    const totalProfitLoss = response.data.reduce((sum, h) => sum + (h.profitAndLoss || 0), 0);

    return {
      success: true,
      data: {
        holdings,
        count: response.data.length,
        summary: {
          totalSoldValue: formatCurrency(totalSoldValue),
          totalCostBasis: formatCurrency(totalCost),
          totalProfitAndLoss: formatCurrency(totalProfitLoss),
          overallReturn: formatPercentage(totalCost > 0 ? (totalProfitLoss / totalCost) * 100 : 0),
        },
      },
    };
  } catch (error) {
    return {
      success: false,
      error: `Failed to fetch sold holdings: ${(error as Error).message}`,
    };
  }
};
